import { map, Observable } from 'rxjs';
import { httpClient } from 'utils/http/httpClient';
import { HttpCall, IHttpClient } from 'utils/http/httpClient.model';

export type BrochureResponseDto =
  | {
      isSuccess: true;
      id: string;
    }
  | {
      isSuccess: false;
      errors: string[];
    };

export type BrochureRequestDto = {
  quoteId: string;
};

export const brochuresApiConnector = (http: IHttpClient) => ({
  generateBrochure(request: BrochureRequestDto): Observable<BrochureResponseDto> {
    return http
      .postJSON<BrochureResponseDto>({
        url: 'api/v1/brochures',
        targetHost: 'AdvisoryBridge',
        body: request,
      })
      .pipe(map(response => response?.payload));
  },
  downloadBrochure(brochureId: string): Observable<HttpCall<Blob>> {
    return http.getBlob({
      url: `api/v1/brochures/${brochureId}`,
      targetHost: 'AdvisoryBridge',
    });
  },
});

export const brochureApi = brochuresApiConnector(httpClient);
